import config from '../../config';

export default {
  url: `${config.api.baseURL}/onboarding/intro`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/onboardingIntro/list.js